import { ColorNames } from '../../constants/colorVars'

export type MappingPillColors = { bg: ColorNames; fg: ColorNames }

/**
 * Maps an organization-mapping status to InfoPill background/foreground colors.
 *
 * Shared across the intake file history table (@adc/ui-core), the Morpheus
 * mapping selector, and the AFI "Data Mapper" dropdown so the version pill reads
 * as one system everywhere: ACTIVE = success (green), DRAFT = caution,
 * ARCHIVED/unknown = gray.
 *
 * Status is accepted as a raw string (the MappingStatus enum value) to keep
 * ui-core decoupled from the @adc/sdk graph types.
 */
export const getMappingPillColors = (
  status: string | null | undefined
): MappingPillColors => {
  switch (status) {
    case 'ACTIVE':
      return { bg: ColorNames.SuccessExtraLight, fg: ColorNames.Success }
    case 'DRAFT':
      return { bg: ColorNames.CautionExtraLight, fg: ColorNames.Caution }
    default:
      return { bg: ColorNames.GrayExtraLight, fg: ColorNames.GrayDark }
  }
}
